module.exports = __webpack_public_path__ + "media/swiftly.d8d435aa.mp3";